import { Component } from '@angular/core';
import { AlarmTableHeaderComponent } from '@components/alarm-table-header/alarm-table-header.component';

@Component({
    selector: 'app-operation-table-header-compact',
    templateUrl: './operation-table-header-compact.component.html',
    styleUrls: [
        './operation-table-header-compact.component.scss',
        '../alarm-table-header/alarm-table-header.component.scss',
        '../alarm-table-header-compact/alarm-table-header-compact.component.scss',
    ],
    standalone: false
})
export class OperationTableHeaderCompactComponent extends AlarmTableHeaderComponent {}
